








































import "./project-card.less";
import Vue from "vue";
import { mapGetters } from "vuex";
import AddClassHover from "./../common/add-class-hover.js";

export default Vue.extend({
  name: "project-card",
  props: {
    id: String,
    project: Object,
    archivedOrDeleted: Boolean,
  },
  directives: { AddClassHover },
  computed: {
    ...mapGetters("project", ["canEdit"]),
    colorClass() {
      let trackingResult = (this as any).project.result;
      if (isNaN(trackingResult)) {
        return {
          "bio-card-default": true,
        };
      } else {
        return {};
      }
    },
    textColor() {
      let color = (this as any).color ? (this as any).color.toUpperCase() : (this as any).color;
      return !color || color === "#FFFFFF" || color === "#F5F2EE" ? "#515A6E" : "#FFFFFF";
    },
    color() {
      let context = this as any;

      if (context.project.archived === true) {
        return "#808080";
      }

      return !!context.project.color ? context.project.color : "#0178B5";
    },
    hasCompletedPercentage() {
      let context = this as any;
      return context.project.completedPercentage !== null && !isNaN(context.project.completedPercentage);
    },
  },
  methods: {
    handleCardClick() {
      this.$router.push({ name: "project", params: { id: this.project.id } });
    },
    handleMenuItemClick(name) {
      this.$emit(name);
    },
  },
});
